import { useCallback, useEffect, useState } from "react";

/**
 * Tracks whether the page has been scrolled past a threshold.
 * The scroll handler is memoised so the effect lists a complete,
 * stable dependency set.
 */
export const useScrolled = (threshold = 20) => {
    const [scrolled, setScrolled] = useState(false);

    const handleScroll = useCallback(
        () => setScrolled(window.scrollY > threshold),
        [threshold],
    );

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);

    return scrolled;
};
